import { authHeader } from "../../../../../helpers/authHeader";
import axios from "axios";


export default {
    loadRequests,
    confirmRequest,
    rejectRequest
};


function loadRequests() {

    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+"/masterdata/requests/376423", requestOptions)
        .then((response) => {
            return response.data.data.requests;
        }, (error) => {
            console.log(error.response);
        });
}


function confirmRequest(id, comment) {

    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+"/masterdata/requests/confirm/" + id, { comment: comment }, requestOptions)
        .then(
            (response) => {
            },
            (error) => {
                console.log(error.response);
            });
}


function rejectRequest(id, comment) {

    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+"/masterdata/requests/reject/" + id, { comment: comment }, requestOptions)
        .then(
            (response) => {
            },
            (error) => {
                console.log(error.response);
            });
}




// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/ManageRequests/api/index.js